import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, IconButton, SxProps, Theme, Typography } from '@mui/material';
import clsx from 'clsx';
import { useMemo } from 'react';

import { AxleDialogShellHeaderProps } from './AxleDialogShell.types';

export const AxleDialogShellHeader = ({
    title,
    actions,
    onClose,
    hideCloseButton = false,
    showScrollShadow = false,
    dragHandleProps,
    className = '',
    children,
    sx,
    ...rest
}: AxleDialogShellHeaderProps) => {
    const titleContent = useMemo(
        () => (typeof title === 'string' ? <Typography variant='h1'>{title}</Typography> : title),
        [title],
    );

    const headerSx = useMemo(
        (): SxProps<Theme> => ({
            gridRow: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 3,
            py: 2,
            borderBottom: '1px solid',
            borderColor: showScrollShadow ? 'divider' : 'transparent',
            ...sx,
        }),
        [showScrollShadow, sx],
    );

    return (
        <DialogTitle
            className={clsx('axle-dialog-shell-header', className)}
            sx={headerSx}
            {...dragHandleProps}
            {...rest}
        >
            {children ?? (
                <>
                    <Box sx={{ flex: 1, minWidth: 0 }}>{titleContent}</Box>
                    {actions}
                    {hideCloseButton || onClose === undefined ? null : (
                        <IconButton aria-label={'Close'} onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    )}
                </>
            )}
        </DialogTitle>
    );
};
